var map = {
	"./New folder/green-1-diamond-open.svg": "ecdf",
	"./New folder/green-1-diamond-solid.svg": "a34a",
	"./New folder/green-1-diamond-striped.svg": "837d",
	"./New folder/green-1-oval-open.svg": "daec",
	"./New folder/green-1-oval-solid.svg": "4eee",
	"./New folder/green-1-oval-striped.svg": "e8a4",
	"./New folder/green-1-squiggly-open.svg": "9eff",
	"./New folder/green-1-squiggly-solid.svg": "ace2",
	"./New folder/green-1-squiggly-striped.svg": "9795",
	"./New folder/green-2-diamond-open.svg": "16fd",
	"./New folder/green-2-diamond-solid.svg": "1d01",
	"./New folder/green-2-diamond-striped.svg": "2254",
	"./New folder/green-2-oval-open.svg": "bcb0",
	"./New folder/green-2-oval-solid.svg": "ec83",
	"./New folder/green-2-oval-striped.svg": "75b0",
	"./New folder/green-2-squiggly-open.svg": "7566",
	"./New folder/green-2-squiggly-solid.svg": "aa2b",
	"./New folder/green-2-squiggly-striped.svg": "c6f1",
	"./New folder/green-3-diamond-open.svg": "c9dc",
	"./New folder/green-3-diamond-solid.svg": "a0d6",
	"./New folder/green-3-diamond-striped.svg": "16c1",
	"./New folder/green-3-oval-open.svg": "9a7a",
	"./New folder/green-3-oval-solid.svg": "b0bf",
	"./New folder/green-3-oval-striped.svg": "badc",
	"./New folder/green-3-squiggly-open.svg": "6c6c",
	"./New folder/green-3-squiggly-solid.svg": "0402",
	"./New folder/green-3-squiggly-striped.svg": "435b",
	"./New folder/purple-1-diamond-open.svg": "fd37",
	"./New folder/purple-1-diamond-solid.svg": "2aa9",
	"./New folder/purple-1-diamond-striped.svg": "1247",
	"./New folder/purple-1-oval-open.svg": "8a13",
	"./New folder/purple-1-oval-solid.svg": "9b43",
	"./New folder/purple-1-oval-striped.svg": "487a",
	"./New folder/purple-1-squiggly-open.svg": "cbc2",
	"./New folder/purple-1-squiggly-solid.svg": "0103",
	"./New folder/purple-1-squiggly-striped.svg": "6f39",
	"./New folder/purple-2-diamond-open.svg": "ef7d",
	"./New folder/purple-2-diamond-solid.svg": "aa02",
	"./New folder/purple-2-diamond-striped.svg": "1421",
	"./New folder/purple-2-oval-open.svg": "8276",
	"./New folder/purple-2-oval-solid.svg": "beea",
	"./New folder/purple-2-oval-striped.svg": "9bf8",
	"./New folder/purple-2-squiggly-open.svg": "945c",
	"./New folder/purple-2-squiggly-solid.svg": "21ee",
	"./New folder/purple-2-squiggly-striped.svg": "05f2",
	"./New folder/purple-3-diamond-open.svg": "244d",
	"./New folder/purple-3-diamond-solid.svg": "d247",
	"./New folder/purple-3-diamond-striped.svg": "7d9d",
	"./New folder/purple-3-oval-open.svg": "abd5",
	"./New folder/purple-3-oval-solid.svg": "db2a",
	"./New folder/purple-3-oval-striped.svg": "ed1f",
	"./New folder/purple-3-squiggly-open.svg": "66b8",
	"./New folder/purple-3-squiggly-solid.svg": "1701",
	"./New folder/purple-3-squiggly-striped.svg": "d797",
	"./New folder/red-1-diamond-open.svg": "a32b",
	"./New folder/red-1-diamond-solid.svg": "afec",
	"./New folder/red-1-diamond-striped.svg": "0aa9",
	"./New folder/red-1-oval-open.svg": "a09d",
	"./New folder/red-1-oval-solid.svg": "fe9e",
	"./New folder/red-1-oval-striped.svg": "e58a",
	"./New folder/red-1-squiggly-open.svg": "5f87",
	"./New folder/red-1-squiggly-solid.svg": "3a04",
	"./New folder/red-1-squiggly-striped.svg": "b8e6",
	"./New folder/red-2-diamond-open.svg": "4564",
	"./New folder/red-2-diamond-solid.svg": "96e1",
	"./New folder/red-2-diamond-striped.svg": "d54c",
	"./New folder/red-2-oval-open.svg": "9835",
	"./New folder/red-2-oval-solid.svg": "704f",
	"./New folder/red-2-oval-striped.svg": "d489",
	"./New folder/red-2-squiggly-open.svg": "e741",
	"./New folder/red-2-squiggly-solid.svg": "6260",
	"./New folder/red-2-squiggly-striped.svg": "99ac",
	"./New folder/red-3-diamond-open.svg": "34fe",
	"./New folder/red-3-diamond-solid.svg": "9f4f",
	"./New folder/red-3-diamond-striped.svg": "68bf",
	"./New folder/red-3-oval-open.svg": "f610",
	"./New folder/red-3-oval-solid.svg": "0407",
	"./New folder/red-3-oval-striped.svg": "b7bd",
	"./New folder/red-3-squiggly-open.svg": "ebfb",
	"./New folder/red-3-squiggly-solid.svg": "118a",
	"./New folder/red-3-squiggly-striped.svg": "01d2",
	"./green-1-diamond-open.svg": "8262",
	"./green-1-diamond-solid.svg": "7338",
	"./green-1-diamond-striped.svg": "ec31",
	"./green-1-oval-open.svg": "6acf",
	"./green-1-oval-solid.svg": "0b41",
	"./green-1-oval-striped.svg": "d9c7",
	"./green-1-squiggly-open.svg": "d496",
	"./green-1-squiggly-solid.svg": "a5c7",
	"./green-1-squiggly-striped.svg": "84e9",
	"./green-2-diamond-open.svg": "1941",
	"./green-2-diamond-solid.svg": "813e",
	"./green-2-diamond-striped.svg": "d677",
	"./green-2-oval-open.svg": "6c2a",
	"./green-2-oval-solid.svg": "d712",
	"./green-2-oval-striped.svg": "12bf",
	"./green-2-squiggly-open.svg": "4390",
	"./green-2-squiggly-solid.svg": "c151",
	"./green-2-squiggly-striped.svg": "6bba",
	"./green-3-diamond-open.svg": "e83f",
	"./green-3-diamond-solid.svg": "bfa0",
	"./green-3-diamond-striped.svg": "acd8",
	"./green-3-oval-open.svg": "3970",
	"./green-3-oval-solid.svg": "19cc",
	"./green-3-oval-striped.svg": "df2a",
	"./green-3-squiggly-open.svg": "b9d4",
	"./green-3-squiggly-solid.svg": "36d1",
	"./green-3-squiggly-striped.svg": "f999",
	"./purple-1-diamond-open.svg": "d759",
	"./purple-1-diamond-solid.svg": "6a23",
	"./purple-1-diamond-striped.svg": "08ab",
	"./purple-1-oval-open.svg": "c1a8",
	"./purple-1-oval-solid.svg": "bc47",
	"./purple-1-oval-striped.svg": "2a8d",
	"./purple-1-squiggly-open.svg": "0401",
	"./purple-1-squiggly-solid.svg": "d863",
	"./purple-1-squiggly-striped.svg": "786f",
	"./purple-2-diamond-open.svg": "b2fe",
	"./purple-2-diamond-solid.svg": "1f91",
	"./purple-2-diamond-striped.svg": "d4ce",
	"./purple-2-oval-open.svg": "eaca",
	"./purple-2-oval-solid.svg": "baef",
	"./purple-2-oval-striped.svg": "2ab5",
	"./purple-2-squiggly-open.svg": "7c71",
	"./purple-2-squiggly-solid.svg": "ed62",
	"./purple-2-squiggly-striped.svg": "fe0a",
	"./purple-3-diamond-open.svg": "3278",
	"./purple-3-diamond-solid.svg": "38a7",
	"./purple-3-diamond-striped.svg": "73dd",
	"./purple-3-oval-open.svg": "0cb2",
	"./purple-3-oval-solid.svg": "081d",
	"./purple-3-oval-striped.svg": "6dfb",
	"./purple-3-squiggly-open.svg": "2f8a",
	"./purple-3-squiggly-solid.svg": "b051",
	"./purple-3-squiggly-striped.svg": "f481",
	"./red-1-diamond-open.svg": "77d9",
	"./red-1-diamond-solid.svg": "74ab",
	"./red-1-diamond-striped.svg": "eef2",
	"./red-1-oval-open.svg": "3c94",
	"./red-1-oval-solid.svg": "1d62",
	"./red-1-oval-striped.svg": "8fa4",
	"./red-1-squiggly-open.svg": "7c7e",
	"./red-1-squiggly-solid.svg": "b0fc",
	"./red-1-squiggly-striped.svg": "1ba4",
	"./red-2-diamond-open.svg": "0f69",
	"./red-2-diamond-solid.svg": "5ab1",
	"./red-2-diamond-striped.svg": "68cf",
	"./red-2-oval-open.svg": "464b",
	"./red-2-oval-solid.svg": "0aff",
	"./red-2-oval-striped.svg": "8284",
	"./red-2-squiggly-open.svg": "99e3",
	"./red-2-squiggly-solid.svg": "bd19",
	"./red-2-squiggly-striped.svg": "d338",
	"./red-3-diamond-open.svg": "aede",
	"./red-3-diamond-solid.svg": "34cb",
	"./red-3-diamond-striped.svg": "66de",
	"./red-3-oval-open.svg": "5d5a",
	"./red-3-oval-solid.svg": "c448",
	"./red-3-oval-striped.svg": "b51a",
	"./red-3-squiggly-open.svg": "bdd0",
	"./red-3-squiggly-solid.svg": "22a0",
	"./red-3-squiggly-striped.svg": "d236",
	"./test-card.svg": "b81e",
	"./test-card2.svg": "3873"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";